import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { LEGAL_CONTACT_EMAIL, LEGAL_ORG_NAME } from '../lib/legal-site-info';

export function PrivacyPage() {
  return (
    <>
      <Seo
        path="/privacy"
        title="Privacybeleid"
        description={`Privacybeleid ${LEGAL_ORG_NAME} — ComfortTool™: je gegevens, lokale opslag van de scan, online betaling, rapport en cookies (AVG).`}
        keywords="ComfortTool privacy, AVG, cookies, gegevens, scan"
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:py-14 text-ct-text">
        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Privacy</h1>
        <p className="mt-2 text-sm text-ct-muted">{LEGAL_ORG_NAME} — indicatieve warmte- en koelcheck</p>
        <div className="prose prose-invert mt-8 max-w-none space-y-6 text-sm leading-relaxed text-ct-muted">
          <section>
            <h2 className="text-lg font-bold text-ct-text">1. Wat verzamelen we?</h2>
            <p className="mt-2">
              Je vult zelf gegevens in over je gebouw (oppervlaktes, isolatie, type gebruik, optioneel
              postcode voor het weerbeeld). Die antwoorden bewaren we op jouw apparaat, zodat je de scan kunt
              onderbreken en later verder kunt gaan. De berekening gebeurt grotendeels bij jou thuis op je telefoon of
              computer; voor klimaat per postcode, het uur-voor-uur-beeld en het uitgeschreven adviesrapport hebben
              we jouw invoer nodig om die stappen voor je uit te rekenen.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">2. Verwerkers en AI</h2>
            <p className="mt-2">
              Als je kiest voor het uitgeschreven adviesrapport (Comfort Plus), sturen we een samenvatting van je
              invoer en uitkomsten naar een gespecialiseerde tekstdienst om er leesbare tekst van te maken. Vul
              alleen in wat je ook aan een adviseur zou durven laten zien; geen wachtwoorden of gevoelige
              persoonsgegevens in vrije tekstvelden.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">3. Betaling</h2>
            <p className="mt-2">
              Afrekenen verloopt via een erkende online betaaldienst. Betalings- en factuurgegevens vallen onder het
              privacybeleid van die partij. Zie ook{' '}
              <Link to="/voorwaarden" className="text-ct-accent hover:underline">
                voorwaarden
              </Link>
              .
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">3a. Account</h2>
            <p className="mt-2">
              Als je een account aanmaakt, slaan we je e-mailadres en een <strong className="text-ct-text">
                beveiligd wachtwoord
              </strong>{' '}
              op. Optioneel kun je aangeven hoe je van ons hoorde. Voor “wachtwoord vergeten” sturen we — als
              e-mail is ingeschakeld — een tijdelijke link (kort geldig). Zonder werkende e-mail krijg je alleen
              een algemene bevestiging, om te voorkomen dat iemand kan uitvissen of je e-mailadres bij ons bekend is.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">4. Cookies</h2>
            <p className="mt-2">
              Zie{' '}
              <Link to="/cookies" className="text-ct-accent hover:underline">
                cookiebeleid
              </Link>
              . Je kunt je voorkeur voor statistiek-cookies kiezen in de banner.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">5. Bewaartermijnen</h2>
            <p className="mt-2">
              Browseropslag blijft staan tot jij ze wist. Serverlogs en providergegevens: volgens onze hosting- en
              leveranciersinstellingen (bewaar zo kort als redelijk voor foutopsporing en beveiliging).
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">6. Je rechten</h2>
            <p className="mt-2">
              Je kunt inzage, correctie of verwijdering vragen voor persoonsgegevens die wij verwerken.{' '}
              {LEGAL_CONTACT_EMAIL ? (
                <>
                  Contact:{' '}
                  <a href={`mailto:${LEGAL_CONTACT_EMAIL}`} className="text-ct-accent hover:underline">
                    {LEGAL_CONTACT_EMAIL}
                  </a>
                  .
                </>
              ) : (
                <>Stel je contactadres in via VITE_LEGAL_CONTACT_EMAIL voor productie.</>
              )}
            </p>
          </section>
          <p className="text-xs text-ct-muted/80">
            Dit document is geen juridisch advies. Laat het nakijken door een jurist voor jouw situatie (AVG /
            consument / B2B).
          </p>
        </div>
      </div>
    </>
  );
}
